/**
 * Flip keys and values for given object
 * @param obj
 */
function objectFlip(obj) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    result[obj[key]] = key;
  });
  return result;
}
export { objectFlip };